import { render, staticRenderFns } from "./MarketValue.vue?vue&type=template&id=10273200&scoped=true"
import script from "./MarketValue.vue?vue&type=script&lang=js"
export * from "./MarketValue.vue?vue&type=script&lang=js"
import style0 from "./MarketValue.vue?vue&type=style&index=0&id=10273200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10273200",
  null
  
)

export default component.exports